import { render } from "./zhenggaojianyanjishu-news.vue?vue&type=template&id=143a4643&scoped=true"
import script from "./zhenggaojianyanjishu-news.vue?vue&type=script&lang=js"
export * from "./zhenggaojianyanjishu-news.vue?vue&type=script&lang=js"

import "./zhenggaojianyanjishu-news.vue?vue&type=style&index=0&id=143a4643&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a4643"]])

export default __exports__